var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-col',[_vm._t("title"),_vm._t("subTitle")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }